export const locadat = [
{
	id:1,
	marque:"Audi",
	img:'./img/audi.jpg',
	model:'TT RS',
	info:'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.'
},
{
	id:2,
	marque:"Bugatti",
	img:'./img/veyron.jpg',
	model:'Veyron 16.4 EB Super-Sports',
	info:'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.'
},
{
	id:3,
	marque:"Lamborghini",
	img:'./img/lambo.jpg',
	model:'Murcielago Suv',
	info:'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.'
},
{
	id:4,
	marque:"Subaru",
	img:'./img/subaru.jpg',
	model:'Impreza STI Wagon',
	info:'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.'
},
{
	id:5,
	marque:"Mercedes-Benz",
	img:'./img/merce.jpg',
	model:'E-Class 220d 1970',
	info:'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.'
}
];
